<div class="template-editor-container">
  <!-- Header -->
  <div class="editor-header">
    <div class="header-left">
      <button class="back-btn" (click)="onBackToList()">
        <svg viewBox="0 0 24 24" class="icon">
          <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
        </svg>
        Back to Templates
      </button>

      <!-- Inline Editable Template Info -->
      @if (template && templateId) {
      <div class="template-info">
        <div
          class="editable-field subject-field"
          [class.editing]="editingField === 'subject'"
          (click)="startEditing('subject')"
          (mouseover)="hoveredField = 'subject'"
          (mouseleave)="hoveredField = null"
        >
          <input *ngIf="editingField === 'subject'" [(ngModel)]="template.subject" (blur)="stopEditing()" (keyup.enter)="stopEditing()" #subjectInput />
          <span *ngIf="editingField !== 'subject'" class="display-text">
            {{ template.subject || 'Email Subject' }}
          </span>
        </div>
        <div
          class="editable-field name-field"
          [class.editing]="editingField === 'name'"
          (click)="startEditing('name')"
          (mouseover)="hoveredField = 'name'"
          (mouseleave)="hoveredField = null"
        >
          <input *ngIf="editingField === 'name'" [(ngModel)]="template.name" (blur)="stopEditing()" (keyup.enter)="stopEditing()" #nameInput />
          <span *ngIf="editingField !== 'name'" class="display-text">
            {{ template.name || 'Template Name' }}
          </span>
        </div>
      </div>
      }
      <!-- Create Template Title -->
      @if (template && !templateId) {
      <div class="template-info">
        <h2>Create Email Template</h2>
      </div>
      }
    </div>

    <div class="header-center">
      <!-- Theme Switcher -->
      @if (availableThemes.length > 0) {
      <div class="theme-switcher">
        <label>Theme:</label>
        <nb-select [value]="selectedTheme?.id" (selectedChange)="onThemeChange($event)" placeholder="Select Theme">
          <nb-option *ngFor="let theme of availableThemes" [value]="theme">
            {{ theme.name }}
          </nb-option>
        </nb-select>
      </div>
      }
      <!-- Description Field -->
      @if (template && templateId) {
      <div class="description-field">
        <input type="text" [(ngModel)]="template.description" placeholder="Template description (optional)" />
      </div>
      }
    </div>

    <div class="header-right">
      <button class="preview-btn secondary" [disabled]="!template || !templateId" (click)="onSendTestEmail()">
        <svg viewBox="0 0 24 24" class="icon">
          <path
            d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"
          />
        </svg>
        Send test email
      </button>
      <button class="save-btn primary" [disabled]="saving || !template" (click)="onSaveTemplate()">
        <svg viewBox="0 0 24 24" class="icon" [class.spin]="saving">
          <path d="M15,9H5V5H15M12,19A3,3 0 0,1 9,16A3,3 0 0,1 12,13A3,3 0 0,1 15,16A3,3 0 0,1 12,19M17,3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V7L17,3Z" />
        </svg>
        {{ headerActionsText() }}
      </button>
    </div>
  </div>

  <!-- Loading State -->
  @if (loading) {
  <div class="loading-container">
    <div class="loading-spinner">
      <svg viewBox="0 0 24 24" class="icon spin">
        <path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
      </svg>
      <p>Loading editor...</p>
    </div>
  </div>
  }
  <!-- Template Creation Form (for new templates) -->
  <div class="template-creation-form">
    @if (!loading && template && !templateId) {
    <div class="creation-card">
      <div class="creation-header">
        <div class="creation-icon">
          <svg viewBox="0 0 24 24" class="icon">
            <path
              d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M11,16.5L6.5,12L7.91,10.59L11,13.67L16.59,8.09L18,9.5L11,16.5Z"
              style="fill: #fff"
            />
          </svg>
        </div>
        <h3>Create Email Template</h3>
        <p>Fill in the basic details below, then save to start building your email template with components.</p>
      </div>
      <div class="creation-form">
        <div class="form-field">
          <svg viewBox="0 0 24 24" class="field-icon">
            <path d="M14,2H6C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
          </svg>
          <input placeholder="Template Name" [(ngModel)]="template.name" required />
        </div>

        <div class="form-field">
          <svg viewBox="0 0 24 24" class="field-icon">
            <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
          </svg>
          <input placeholder="Email Subject" [(ngModel)]="template.subject" required />
        </div>

        <div class="form-field">
          <svg viewBox="0 0 24 24" class="field-icon">
            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
          </svg>
          <textarea placeholder="Description (optional)" [(ngModel)]="template.description" rows="3"></textarea>
        </div>

        <div class="form-actions">
          <button class="create-btn" (click)="onSaveTemplate()" [disabled]="saving || !template.name || !template.subject">
            <svg viewBox="0 0 24 24" class="icon" [class.spin]="saving">
              <path style="fill: #fff" d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z" />
            </svg>
            {{ saving ? 'Creating Template...' : 'Create Template' }}
          </button>
        </div>
      </div>
    </div>
    }

    <!-- Full Editor Content (for existing templates) -->
    <div *ngIf="!loading && template && templateId" class="editor-content">
      <!-- Left Sidebar - Components Library -->
      <div class="editor-sidebar">
        <div class="sidebar-header">
          <h3>Components</h3>
          <p>Drag components to add them to your template</p>
        </div>

        <div class="components-library">
          <div class="component-category" *ngFor="let category of getComponentCategories()">
            <h4>{{ getCategoryLabel(category) }}</h4>
            <div class="category-components tw-h-96 tw-overflow-y-auto">
              <div *ngFor="let component of getComponentsByCategory(category)" class="component-item" draggable="true" (dragstart)="onComponentDragStart($event, component)">
                <div class="component-icon">
                  <svg viewBox="0 0 24 24" class="icon">
                    <path [attr.d]="getComponentIconPath(component.slug)"></path>
                  </svg>
                </div>
                <div class="component-info">
                  <span class="component-name">{{ component.name }}</span>
                  <span class="component-description">{{ component.description }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Canvas - Template Builder -->
      <div class="editor-canvas">
        <div class="canvas-content">
          <div class="email-preview-container">
            <div class="email-preview">
              <!-- Template Components Drop Zone -->
              <div class="components-drop-zone" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
                <!-- Existing Components -->
                <div *ngFor="let component of template.components || []; let i = index; trackBy: trackByComponent" class="template-component" [attr.data-index]="i">
                  <div class="component-controls">
                    <button class="control-btn" (click)="moveComponentUp(i)" [disabled]="i === 0">
                      <svg viewBox="0 0 24 24" class="icon">
                        <path d="M7,14L12,9L17,14H7Z" />
                      </svg>
                    </button>
                    <button class="control-btn" (click)="moveComponentDown(i)" [disabled]="i === (template.components?.length || 0) - 1">
                      <svg viewBox="0 0 24 24" class="icon">
                        <path d="M7,10L12,15L17,10H7Z" />
                      </svg>
                    </button>
                    <button class="control-btn danger" (click)="removeComponent(i)">
                      <svg viewBox="0 0 24 24" class="icon">
                        <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
                      </svg>
                    </button>
                  </div>

                  <!-- Component Renderer -->
                  <div
                    class="component-content"
                    [innerHTML]="renderComponent(component)"
                    (click)="selectComponent(component)"
                    [class.selected]="selectedComponent === component"
                  ></div>
                </div>

                <!-- Empty State -->
                <div *ngIf="!template.components || template.components.length === 0" class="empty-drop-zone">
                  <svg viewBox="0 0 24 24" class="icon">
                    <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z" />
                  </svg>
                  <h4>Drop components here</h4>
                  <p>Drag components from the sidebar to build your email template</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Sidebar - Component Properties -->
      <div class="editor-properties">
        <div class="properties-header">
          <h3>Properties</h3>
        </div>

        <div class="properties-content" *ngIf="selectedComponent">
          <ngx-component-properties
            [component]="selectedComponent"
            [theme]="selectedTheme"
            [availableComponents]="availableComponents"
            (propertiesChange)="onComponentPropertiesChange($event)"
          >
          </ngx-component-properties>
        </div>

        <div class="no-selection" *ngIf="!selectedComponent">
          <svg viewBox="0 0 24 24" class="icon">
            <path
              d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.22,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.22,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.68 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"
            />
          </svg>
          <p>Select a component to edit its properties</p>
        </div>
      </div>
    </div>
  </div>
</div>
